import {Box} from "@mui/material";
import {EditPopup} from "components/Admin/Pages/EditPopup/EditPopup";

import {Permissions} from "dto/user-dto";
import {userService} from "services/userService";
import {BooleanInput, CheckboxGroupInput, NumberInput, PasswordInput, TextInput, useTranslate} from "react-admin";

export const UserEdit: React.FC = () => {
  const t = useTranslate();

  const permissions = Object.keys(Permissions).map((permission) => ({
    id: permission,
    name: t(`resources.users.options.permissions.${permission}`),
  }));

  return (
    <EditPopup
      queryKey="users"
      updateQuery={userService.update}
      getRecordQuery={userService.getById}
    >
      <TextInput source="username" fullWidth size="medium"/>
      <TextInput source="email" fullWidth size="medium"/>
      <PasswordInput source="password" fullWidth size="medium"/>
      <Box sx={{display: "flex", flexDirection: "row", gap: "10px"}}>
        <BooleanInput source="active" defaultValue={true}/>
        <BooleanInput source="emailIsConfirmed" defaultValue={true}/>
      </Box>
      <Box sx={{display: "flex", flexDirection: "row", gap: "10px"}}>
        <NumberInput source="goldCapss" size="medium" min={0} defaultValue={0} fullWidth/>
        <NumberInput source="sparks" size="medium" min={0} defaultValue={0} fullWidth/>
        <NumberInput source="gums" size="medium" min={0} defaultValue={0} fullWidth/>
      </Box>
      <CheckboxGroupInput
        source="permissions"
        choices={permissions}
        defaultValue={[Permissions.PLAY]}
        translateChoice={true}
      />
    </EditPopup>
  );
};